const config = {
    baseUrl: '//10.16.30.156:8080',
    vendorUrl: '//10.16.15.132/badger/ci/vendor',
    groupUrl: '//10.16.15.132/badger/ci/group'
}

export default config
